export const isSecondaryQs = (_key: string): boolean => false
